import { observer } from 'mobx-react-lite'
import { FC, useContext, useEffect } from 'react'
import { Context } from '..'

import styles from '../styles/Policy.module.scss'
// import useWindowDimensions from '../core/hooks/useWindowDimensions'
// import CardWrap from './_shared/CardWrap/CardWrap'
// import XTitle from './_shared/XTitle'
// import Breadcrumbs from './_shared/Breadcrumbs/Breadcrumbs'

const Rules: FC = () => {
	const { store } = useContext(Context)

	useEffect(() => {
		return () => {}
	}, [])

	return (
		<>
			{/* <CardWrap> */}
			{/* <Breadcrumbs /> */}
			{/* <XTitle>
					{store.locale == 'ru-RU' ? 'Правила и условия сервиса' : 'Terms and conditions of service'}
				</XTitle> */}

			{/* <h1>{store.locale == 'ru-RU' ? 'Правила и условия сервиса' : 'Terms and conditions of service'}</h1> */}

			{store.locale !== 'ru-RU' ? (
				<div className={styles.policy}>
					<div className='container'>
						<p>
							These terms and conditions, as may be amended from time to time, apply to all services
							provided directly or indirectly (through partners) online via email, phone, website or
							mobile device. By visiting, browsing or using the online platform on any device or website
							and/or making a booking, you acknowledge that you have read, understood and agreed to the
							terms and conditions described below (including the privacy statement).
							<br />
							These pages, their content and their infrastructure, as well as the online booking service
							for creative services, which is provided through this application-online platform (the
							"service"), are owned, operated and provided by PODCASTBERY ("podcastbery.ru", "us", "we" or
							"our") and are provided only for your personal, non-commercial use in accordance with the
							terms and conditions set out below.
						</p>

						<h6>1. Description of services</h6>

						<p>
							Through this application, we (PODCASTBERY and its affiliate partners (distribution partners)
							provide an online platform through which all creative service providers (e.g. rehearsal
							spaces, recording studios, dance halls, photo studios, cover bands, etc., collectively
							referred to as "creative service provider(s") can list their services (in the form of
							rehearsal rooms, recording studios, photo studios, dance halls, creative spaces, etc.) for
							booking, and users of this application can make bookings and pay for such services. By
							making a booking through the PODCASTBERY application, you enter into a direct (legally
							binding) contractual relationship with the creative service provider from which you are
							booking. From the moment you make a booking, we act solely as an intermediary between you
							and the creative service provider, transmitting the details of your booking to the relevant
							creative service provider creative services and sending you an email confirmation of your
							booking on behalf of the provider.
							<br />
							When providing our services, the information provided is based on the information provided
							to us by the creative services providers. Creative services providers have access to the
							extranet and are solely responsible for updating the information on prices, availability and
							other data displayed on our application. Although we do our utmost to ensure the quality of
							the services provided, we cannot verify or guarantee the accuracy, completeness or
							correctness of all information and we accept no liability for any errors (including manifest
							and typographical errors), any failures (whether due to (temporary and/or partial)
							breakdown, repair, improvement or support of our website/app or for other reasons),
							inaccurate, unreliable or false information or non-receipt of information. Each creative
							services provider is at all times responsible for the accuracy, completeness and correctness
							of the (descriptive) information (including prices and availability) displayed on our online
							platform. Our application is not and should not be construed as a recommendation or
							endorsement of the quality, level of service or star rating of any creative services
							offered.
							<br />
							Our services are provided for individual, non-commercial use only. As such, you may not
							resell, deep-link, use, copy, monitor, display, download or reproduce any portion of the
							content or information, software, products or services available on our application for any
							commercial or competitive activity or purpose.
						</p>

						<h6>2. Rates, Prices and Charges.</h6>

						<p>
							Our mobile app prices are very competitive. All prices in the PODCASTBERY app are for the
							entire booking period, unless otherwise stated on our website or in the booking confirmation
							email. In the event of a no-show or exceeding the free cancellation period, the booking
							system automatically assigns a fee to the booker's profile equal to the amount of the unpaid
							booking.
							<br />
							Canceling a booked time within the free cancellation policy waives the cancellation fee and
							allows further bookings through the app.
							<br />
							In the event of a repeated no-show or exceeding the free cancellation period, the
							PODCASTBERY system blocks the user from canceling future bookings. We want you to pay the
							lowest possible price for a creative service. If after making a booking you find a service
							at this creative services facility on the Internet with identical booking conditions at a
							lower price, we will offer you the same price according to the terms and conditions of the
							Best Price Guarantee.
							<br />
							Obvious errors (including typos) are not legally binding.
							<br />
							All special promotions and offers are marked accordingly.
						</p>

						<h6>3. Privacy</h6>
						<p>
							PODCASTBERY cares about the safety of your personal data. Please read the Privacy section.
						</p>

						<h6>4. Free services</h6>
						<p>
							Our service is absolutely free for you, because unlike many other companies, we do not
							charge you for our service and do not add additional fees (for booking) to the cost of the
							service.
						</p>

						<h6>5. Cancellation and No-Show</h6>
						<p>
							By making a booking with a Creative Services Venue, you accept and agree to the free/paid
							cancellation policy, the no-show policy, and any additional terms and conditions (of
							Creative Services) of the Creative Services Venue that may apply to your booking or during
							your use of the service. This includes services and/or products offered at the creative
							services venue (the terms and conditions of creative services can be obtained from the
							relevant creative services venue). Please note that certain rates and special offers cannot
							be cancelled or changed. We recommend that you carefully read the description of the
							specific creative space, or service, for example, and the special rules before making a
							booking.
							<br />
							If you wish to review, change or cancel your booking, please contact the creative services
							venue. Please note that you may be charged a cancellation fee in accordance with the
							creative services venue's cancellation and no-show policies. We recommend that you carefully
							read the free/paid cancellation and no-show policies before making a booking and make
							payments in a timely manner as required for the relevant booking.
							<br />
							If you are running late, arriving late or near the end of your booking on the day of the
							service, please notify the creative services venue promptly/promptly. This way the property
							will know when to expect you, which will help to avoid cancellation of the booking and
							no-show fees. PODCASTBERY.ru is not responsible for the consequences of your late start to
							use the service, as well as the cancellation of the booking or no-show fee that is charged
							by the creative services facility.
						</p>

						<h6>6. (Further) Correspondence and Communication</h6>
						<p>
							By completing a booking, you agree to receive an email that we may send you directly when
							you book and use the service, with information about the relevant booking, certain data and
							special offers (including special offers from third parties) related to your booking, as
							well as an email that we may send you immediately after your stay at the creative services
							facility, inviting you to complete our review form for this place. Please see our Privacy
							section for information on how we may contact you.
							<br />
							PODCASTBERY.RU does not accept any responsibility for any communications with service
							providers that take place on or through its platform. You cannot claim any rights based on
							any request or message sent to a service provider or confirmation (in any form) that a
							request or message has been received. PODCASTBERY cannot guarantee that a request or message
							will be (properly and timely) received/read, fulfilled or accepted by the service provider.
							<br />
							To complete and guarantee a booking, you must provide a correct email address. We are not
							responsible for (and have no obligation to check) any incorrect or misspelled email address,
							incorrectly specified (mobile) phone number.
						</p>

						<h6>7. Ordering, stars and reviews</h6>
						<p>
							By default, the creative services provided on our website are ordered alphabetically and in
							accordance with the filters you have selected, without any priority of placement in the
							list. All reviews left through the form sent by us to your email serve to form the star
							rating, which will be used later as a filter for the convenience of finding a music service.
							Any review is used to form a set of measures for working with the quality of service to
							users of the application by PODCASTBERY partners.
						</p>

						<h6>8. Limitation of liability</h6>
						<p>
							Subject to the limitations set out in these terms and conditions and in accordance with the
							law, we are only liable for compensation for direct damages actually incurred, paid or
							caused as a result of improper performance of our obligations in the provision of services
							within the amount of the total cost of your order, as stated in the email confirming your
							booking. Notwithstanding this, neither we nor any of our officers, directors, employees,
							representatives, subsidiaries, affiliates, distributors, affiliate distribution partners,
							licensees, agents or others involved in creating, sponsoring, promoting or otherwise making
							available this website and its content will be liable to the fullest extent permitted by law
							for (1) any punitive, special, indirect or consequential loss or damages whatsoever,
							including without limitation loss of production, profits, revenue, loss of contract, loss of
							or damage to goodwill, loss of claim, (2) any inaccuracy relating to the (descriptive)
							information (including prices, availability and ratings) of the accommodation made available
							on our application, (3) services or products offered by the accommodation or other business
							partners, (4) any (direct, indirect, consequential or punitive) losses, damages or costs
							suffered, incurred or paid by you and arising out of or in connection with the use,
							inability to use or interruption of our application or (5) any (personal) injury, death,
							property damage or other (direct, indirect, consequential or punitive) losses, damages or
							expenses suffered, incurred or paid by you due to (legal) acts, errors, breaches,
							negligence, willful misconduct, omissions, non-performance, misrepresentations, wrongdoing
							or strict (simple) liability (in whole or in part) of the hosting provider or any other
							business partners (including their employees, directors, officers, agents, representatives
							or affiliates) whose products or services are (directly or indirectly) made available,
							offered or promoted on or through the application, including any cancellation, overbooking,
							strike, force majeure or any other event beyond our control.
							<br />
							Whether or not the hosting provider charges you for the service (or already written off), or
							we facilitate the payment of the cost of the service, you agree and acknowledge that in all
							cases the object of provision of creative services is responsible for the collection,
							withholding, transfer and payment of the relevant taxes subject to calculation and payment
							from the total cost of the order to the authorized tax authorities.
							<br />
							PODCASTBERY.ru is not responsible for the transfer, collection, withholding or payment of
							the relevant taxes from the cost of the number to the authorized tax authorities.
						</p>

						<h6>9. Intellectual Property Rights</h6>
						<p>
							Unless otherwise stated, all software required to provide our services and/or used in our
							application and the intellectual property rights (including copyright and related rights) in
							the content, information and materials posted on the application are owned by PODCASTBERY,
							its suppliers or providers. PODCASTBERY retains exclusive ownership, use and control of (all
							intellectual property rights) (the look and feel (including infrastructure)) of the
							website/s on which the service is available (including guest reviews and translated content)
							and you have no rights to copy, scrape or harvest the website, create (hyper-/deep) links to
							the website, publish, promote, market, integrate, use, combine or otherwise use the content
							(including any translations thereof and guest reviews) or our brand without our express
							written permission. In the event that you (in whole or in part) use or combine our
							(translated) content (including guest reviews) or otherwise have intellectual property
							rights in the website or any (translated) content or guest reviews, you hereby transfer and
							assign all such intellectual property rights to PODCASTBERY. Any unlawful use or commission
							of any of the above will constitute a material infringement of our intellectual property
							rights (including copyright and related rights and database producer rights).
						</p>

						<h6>10. About PODCASTBERY</h6>
						<p>
							The online booking service for creative services is provided by PODCASTBERY and is the
							property of the legal entity IP Kazantsev V.D., registered in accordance with Russian law on
							February 13, 2018. INN 245211492400
							<br />
							Last updated: October 2024
						</p>
					</div>
				</div>
			) : (
				<></>
			)}

			{store.locale === 'ru-RU' ? (
				<div className={styles.policy}>
					<div className='container'>
						<div className='row'>
							<div className='col-12'>
								<div className={styles.wrapper}>
									<h1>ПРАВИЛА И УСЛОВИЯ СЕРВИСА</h1>
									<p className={styles.addr}>
										Дата вступления в силу 29.01.2026
										<br />
										г. Москва редакция от 18.06.2026
									</p>

									<p className={styles.addr}>
										Настоящие Правила работы на Сервисе (далее – «Правила») разработаны Оператором,
										ИП Казанцевой Викторией Александровной, и устанавливают порядок, технические
										условия, процедуры и стандарты взаимодействия Поставщика с Сервисом, а также
										права и обязанности Поставщика при использовании функционала Сайта{' '}
										<a href='https://podcastbery.ru/'>https://podcastbery.ru/</a>.
									</p>

									<p>
										<b>ОСНОВНЫЕ ПОНЯТИЯ</b>
									</p>
									<p>
										<b>Поставщик услуг (Поставщик)</b> — юридическое лицо, индивидуальный
										предприниматель или самозанятый, применяющий в своей деятельности специальный
										налоговый режим «Налог на профессиональный доход», имеющие законное право
										вступать в договорные отношения с Оператором, а также размещать объекты для
										бронирования на сайте{' '}
										<a href='https://podcastbery.ru/'>https://podcastbery.ru/</a>, а также
										информацию о дополнительных платных и бесплатных услугах.
									</p>
									<p>
										<b>Услуги Поставщика</b> — услуги, оказываемые Поставщиком, могут включать в
										себя предоставление в почасовую аренду Залов, оборудования, а также иные
										дополнительные платные и бесплатные услуги Поставщика.
									</p>
									<p>
										<b>Личный кабинет</b> — интерактивное пространство, доступ к которому появляется
										при регистрации на сайте, позволяющее Сторонам обмениваться информацией и
										документами в электронном виде. Вход в личный кабинет осуществляется при помощи
										логина и пароля, известных только Поставщику услуг, при этом Поставщик услуг
										гарантирует, что данная информация используется исключительно им для
										осуществления взаимодействия с Оператором и третьими лицами.
									</p>
									<p>
										<b>Сайт (Сервис)</b> — информационный ресурс Оператора в интернете,
										расположенный по адресу{' '}
										<a href='https://podcastbery.ru/'>https://podcastbery.ru/</a>, на котором
										осуществляется размещение Услуг Поставщика.
									</p>
									<p>
										<b>Зал</b> — пространство, информация о котором оформлена Поставщиком услуг
										в соответствии с требованиями Сайта, и размещена Оператором на Сайте для
										осуществления дальнейшего его бронирования Заказчиками.
									</p>
									<p>
										<b>Система бронирования</b> — информационная система, содержащая информацию,
										касающуюся наличия свободных часов в Залах, а также дополнительных услугах,
										тарифах и правилах их применения, в том числе условиях предоставления
										предлагаемых услуг. Информация в Системе бронирования размещается на Сайте
										непосредственными Поставщиками данных услуг или их полномочными представителями.
										Информация в системе бронирования может в любой момент быть изменена или
										дополнена. Система бронирования также может быть размещена непосредственно на
										сайте Поставщика услуг.
									</p>
									<p>
										<b>Правила Поставщика (Студии)</b> — внутренние правила и условия оказания услуг
										Поставщиком, включая, но не ограничиваясь, порядок и сроки внесения предоплаты
										Заказчиком, размер предоплаты, условия отмены и переноса бронирования. Правила
										Поставщика не должны противоречить условиям Договора и Пользовательскому
										соглашению Сервиса.
									</p>
									<p>
										<b>Агентское вознаграждение</b> — установленное в соответствии с Тарифом, а
										также условиями Договора вознаграждение, которое Поставщик услуг обязуется
										оплатить Оператору.
									</p>
									<p>
										<b>Заказчик</b> — лицо, непосредственно осуществляющее бронирование, которому
										Поставщик оказывает услуги по предоставлению Зала и/или иные услуги.
									</p>
									<p>
										<b>Заказ</b> — должным образом оформленный запрос Заказчика на получение услуг
										по бронированию Залов Поставщика, а также дополнительных услуг, выбранных на
										Сайте.
									</p>
									<p>
										<b>Тариф</b> — определенный тарифный план Оператора, который зависит от срока
										предоставления партнерского доступа для размещения услуг и иных условий Сервиса.
										Тариф указывается в Договоре между сторонами и/или выставляется Оператором в
										личном кабинете Поставщика услуг и является неотъемлемой частью заключенного
										Договора. Информация о Тарифах размещена по адресу:{' '}
										<a href='https://podcastbery.ru/connect'>https://podcastbery.ru/connect</a>.
									</p>
									<p>
										<b>Правила Бронирования</b> — правила взаимодействия Заказчика с Поставщиком
										услуг для бронирования определенной услуги.
									</p>
									<p>
										<b>Автопродление</b> — автоматическое списание денежных средств по Тарифу на
										следующий срок по окончании предыдущего срока Тарифного плана или Пробного
										периода.
									</p>
									<p>
										<b>Пробный период</b> — бесплатный пробный доступ к Сервису. Продолжительность
										Пробного периода определяется Оператором самостоятельно.
									</p>
									<p>
										<b>1. ОБЩИЕ ПОЛОЖЕНИЯ. СТАТУС ПРАВИЛ</b>
									</p>
									<p>
										<b>1.1.</b> Настоящие Правила работы на Сервисе (далее — «Правила») разработаны
										Оператором — ИП Казанцевой Викторией Александровной, и представляют собой
										систематизированный свод процедурных норм, технических условий, стандартов и
										требований, детализирующих порядок исполнения Сторонами обязательств по Договору
										публичной оферты (партнерскому соглашению) (далее — «Договор»).
									</p>
									<p>
										<b>1.2.</b> Правила являются неотъемлемой частью Договора. Акцепт условий
										Договора Поставщиком означает полное и безоговорочное принятие им настоящих
										Правил в редакции, действующей на момент акцепта.
										<br />
										Все термины и определения, используемые в Правилах, имеют то же значение, что и
										в Договоре.
										<br />В случае возникновения коллизий между текстом Договора и текстом настоящих
										Правил, приоритет имеют положения Договора.
									</p>
									<p>
										<b>1.3.</b> Оператор оставляет за собой право в одностороннем порядке вносить
										изменения и/или дополнения в текст настоящих Правил в связи с изменениями в
										законодательстве, оптимизацией работы Сервиса или иными существенными причинами.
										Новая редакция Правил вступает в силу с момента ее публикации на Сайте в
										соответствующем разделе, если иной срок вступления в силу не указан
										непосредственно в тексте изменений. Обязанность по самостоятельному и
										регулярному ознакомлению с актуальной редакцией Правил возлагается на
										Поставщика.
									</p>
									<p>
										<b>1.4.</b> К отношениям, возникающим при применении настоящих Правил, в части,
										не урегулированной ими, подлежат применению положения Договора и действующего
										законодательства Российской Федерации.
									</p>
									<p>
										<b>1.5.</b> Оператор после регистрации Поставщика услуг предоставляет ему доступ
										к Личному кабинету на Сайте, а также возможность размещать информацию о
										предоставляемой Услуге если такой доступ осуществляется в соответствии с
										выбранным Поставщиком Тарифом.
									</p>
									<p>
										<b>1.6.</b> Поставщик услуг размещает информацию об Услуге в Личном кабинете, в
										специально предназначенных для этого полях, в соответствии с правилами
										размещения материалов на Сайте.
									</p>
									<p>
										<b>1.7.</b> Оператор обеспечивает размещение информации о Зале, а также иных
										услугах Поставщика услуг, в открытом доступе на Сайте.
									</p>
									<p>
										<b>1.8.</b> Оператор обеспечивает возможность бронирования услуги Поставщика на
										Сайте путем внесения Заказчиком предоплаты в размере{' '}
										<b>100% от стоимости Услуги</b>, указанной на Сайте, в соответствии с выбранным
										Поставщиком Тарифом.
									</p>
									<p>
										<b>1.9.</b> Для расчетов на Сайте Оператор использует платежный сервис{' '}
										<b>ЮMoney</b> в соответствии с правилами работы платежного сервиса и партнерской
										программы, доступными по ссылке:{' '}
										<a href='https://yoomoney.ru/page?id=527067&lang=ru' target='_blank'>
											https://yoomoney.ru/page?id=527067&lang=ru
										</a>
										.
									</p>
									<p>
										<b>1.10.</b> Дополнительные услуги предоставляются Оператором по запросу
										Поставщика услуг и оплачиваются Поставщиком дополнительно.
									</p>
									<p>
										<b>2. ПОРЯДОК РЕГИСТРАЦИИ, ВЕРИФИКАЦИИ И ПУБЛИКАЦИИ КАРТОЧКИ ПОСТАВЩИКА</b>
									</p>
									<p>
										<b>2.1.</b> Поставщик, принявший условия Договора, получает доступ к Личному
										кабинету (для тарифов <b>«PRO»</b> и <b>«PREMIUM»</b>).
										<br />
										Для активации возможности приема Заказов и публикации в каталоге Сервиса
										Поставщик обязан в полном объеме и с соблюдением установленных требований
										создать и наполнить карточку своего Зала (Студии).
									</p>
									<p>
										<b>2.2.</b> <b>Срок и минимальные требования к содержанию карточки.</b>
									</p>
									<p>
										<b>2.2.1.</b> Поставщик обязан завершить формирование карточки Зала в течение{' '}
										<b>7 (семи) календарных дней</b> с момента успешной регистрации и получения
										доступа к Личному кабинету.
										<br />
										Несоблюдение данного срока является основанием для приостановки или
										аннулирования регистрации по усмотрению Оператора.
									</p>
									<p>
										<b>2.2.2.</b> Минимальный объем информации, необходимый для допуска карточки к
										публикации в общем каталоге Сервиса, включает:
									</p>
									<ul>
										<li>
											<b>a) Наименование:</b> Полное и корректное наименование Студии (Зала),
											под которым Поставщик осуществляет деятельность.
										</li>
										<li>
											<b>b) Адреса:</b> Юридический адрес Поставщика и точный, детализированный
											адрес места оказания услуг (фактический адрес Зала). В случае
											несовпадения адресов — указание обоих является обязательным.
										</li>
										<li>
											<b>c) Фотоматериалы:</b> не менее трех (3) уникальных фотографий высокого
											качества и разрешения, на которых запечатлены интерьер, рабочая зона,
											используемое оборудование и общий вид помещений Зала. Фотографии должны
											достоверно, без искажений отражать текущее состояние Зала на момент
											загрузки. Запрещается использование стоковых изображений, фотографий других
											объектов, коллажей, на которых присутствуют элементы графического дизайна,
											скрывающие реальные недостатки.
										</li>
										<li>
											<b>d) Описание:</b> Детализированное текстовое описание, включающее площадь
											помещений, особенности планировки и акустической отделки, исчерпывающий
											перечень основного и дополнительного оборудования (с указанием моделей, где
											это уместно), наличие и характеристики зон отдыха, клиентской инфраструктуры
											и иные отличительные признаки, имеющие значение для Заказчика.
										</li>
										<li>
											<b>e) Прайс-лист:</b> Исчерпывающий и структурированный прайс-лист с четким
											указанием:
											<ul>
												<li>
													Стоимости аренды Зала за <b>1 (один) час</b>.
												</li>
												<li>
													Перечня всех дополнительных платных услуг (работа звукорежиссера,
													инженера, аренда дополнительного оборудования, услуги видеомонтажа,
													обработки звука и т.д.) с указанием стоимости каждой услуги или
													метода ее расчета (почасовая, фиксированная).
												</li>
											</ul>
										</li>
										<li>
											<b>f) График доступности:</b> Актуальный календарь доступности Зала для
											бронирования, синхронизированный с внутренним расписанием и производственным
											календарем Поставщика. Поставщик несет ответственность за актуальность
											отображаемого графика.
											<br />
										</li>
										<li>
											<b>g) Контакт для связи:</b> Контактные данные (имя, должность, номер
											телефона, мессенджер) уполномоченного представителя Поставщика,
											ответственного за оперативное взаимодействие с Оператором и подтверждение
											Заказов.
										</li>
									</ul>
									<p>
										<b>2.3.</b> <b>Процедура проверки (модерации) и верификации.</b>
									</p>
									<p>
										<b>2.3.1.</b> Предоставленная Поставщиком информация подлежит обязательной
										предварительной проверке (модерации) Оператором.
										<br />
										Целью модерации является подтверждение полноты, достоверности данных, их
										соответствия требованиям настоящих Правил, Договора, а также законодательству
										РФ.
									</p>
									<p>
										<b>2.3.2.</b> В рамках проверки Оператор, в том числе через службу безопасности,
										вправе:
										<ul>
											<li>
												Затребовать у Поставщика предоставления дополнительных документов,
												подтверждающих указанные сведения (нотариально заверенные копии
												свидетельства о государственной регистрации (ОГРНИП/ОГРН), выписки из
												ЕГРИП/ЕГРЮЛ, документов, подтверждающих право пользования помещением
												(договор аренды, свидетельство о собственности), разрешительной
												документации при ее необходимости).
											</li>
											<li>
												Осуществить выборочную или плановую проверку Зала с целью визуального
												сопоставления заявленных характеристик с фактическими.
											</li>
										</ul>
									</p>
									<p>
										<b>2.3.3.</b> Оператор вправе отказать в публикации карточки Поставщика или
										удалить уже опубликованную карточку без предварительного уведомления в случае:
										<ul>
											<li>Обнаружения недостоверных, неполных или противоречивых сведений.</li>
											<li>Несоответствия фотоматериалов реальному состоянию Зала.</li>
											<li>
												Несоблюдения минимальных требований к наполнению карточки, установленных
												п. 2.2.2. настоящих Правил.
											</li>
											<li>
												Предоставления информации или материалов, нарушающих законодательство
												РФ, права третьих лиц или условия Договора.
											</li>
										</ul>
									</p>
									<p>
										<b>2.3.4.</b> До завершения процедуры модерации и принятия положительного
										решения о публикации доступ Поставщика к функционалу приема и обработки Заказов
										через Сервис является технически ограниченным или невозможным.
										<br />
										Сроки проведения модерации определяются Оператором самостоятельно.
									</p>
									<p>
										<b>2.4.</b>{' '}
										<b>
											Специальные условия формирования и ведения карточки для тарифа «Standart».
										</b>
									</p>
									<p>
										<b>2.4.1.</b> Для Поставщиков, выбравших тариф <b>«Standart»</b>, первоначальное
										наполнение карточки Зала (Студии) на Сайте осуществляется Оператором на
										основе информации и материалов, предоставленных Поставщиком в процессе
										регистрации и согласования.
									</p>
									<p>
										<b>2.4.2.</b> Поставщику на тарифе «Standart» <u>не предоставляется доступ</u> к
										функционалу самостоятельного редактирования, обновления или дополнения
										информации в его карточке через Личный кабинет.
										<br />
										Все запросы на изменение информации должны направляться в службу поддержки
										Оператора.
									</p>
									<p>
										<b>2.4.3.</b> Публичная карточка Поставщика на тарифе «Standart» отображается на
										Сайте в следующем ограниченном формате:
										<ul>
											<li>
												<b>Медиа:</b> Не более <b>3 (трех) фотографий</b> Зала.
											</li>
											<li>
												<b>Контент:</b> Карточка не включает разделы с подробным описанием,
												перечнем оборудования, примерами работ, портфолио, списком
												дополнительных услуг (кроме базовой почасовой аренды), отзывами
												менеджеров и иным расширенным контентом.
											</li>
											<li>
												<b>Размещение:</b> Карточка размещается в общем каталоге Сервиса без
												какого-либо приоритетного продвижения, понижения в поисковой выдаче или
												участия в специальных промо-разделах.
											</li>
										</ul>
									</p>
									<p>
										<b>2.4.4.</b> Информация в карточке Поставщика на тарифе «Standart» (включая
										фотографии, название, базовый прайс) может быть обновлена{' '}
										<b>не чаще одного раза в 6 (шесть) календарных месяцев</b> по письменному
										запросу Поставщика, направленному в поддержку Оператора.
										<br />
										Оператор оставляет за собой право отклонить запрос или установить плату за
										внеочередное внесение изменений.
									</p>
									<p>
										<b>2.4.5.</b> Поставщикам на тарифе «Standart» <u>не предоставляется доступ</u>{' '}
										к внутренней CRM-системе (системе управления взаимоотношениями с клиентами)
										Сервиса, а также к связанной с ней аналитике и инструментам автоматизации
										коммуникаций.
									</p>
									<p>
										<b>3. СТАНДАРТЫ РАБОТЫ С ЗАКАЗАМИ И ИНФОРМАЦИОННОГО ВЗАИМОДЕЙСТВИЯ</b>
									</p>
									<p>
										<b>3.1.</b> <b>Порядок для тарифа «PRO» (сервисный сбор).</b>
									</p>
									<p>
										<b>3.1.1.</b> Сервис выступает в качестве первичного контактного центра для
										клиентов, заинтересованных в бронировании услуг Поставщиков на данных тарифах.
									</p>
									<p>
										<b>3.1.2.</b> На публичной странице (карточке) Поставщика на тарифе «PRO» в
										разделе контактов отображается специальный номер телефона, принадлежащий
										Оператору.
										<br />
										Прямой контактный телефон и иные способы прямой связи Поставщика на этих тарифах{' '}
										<u>не публикуются</u> в открытом доступе на Сайте.
									</p>
									<p>
										<b>3.1.3.</b> <b>Процесс обработки входящего обращения клиента:</b>
										<ol>
											<li>
												<b>Менеджер Оператора принимает</b> входящий звонок (или иное обращение
												через Сайт) от клиента.
											</li>
											<li>
												<b>Менеджер проводит первичный сбор информации:</b> уточняет потребности
												клиента, консультирует по данным, доступным в публичном профиле
												Поставщика (актуальное расписание, типы помещений, базовые тарифы,
												состав оборудования).
											</li>
											<li>
												<b>После первичного контакта и согласования</b> примерных параметров,
												менеджер Оператора в течение <b>15 (пятнадцати) минут</b> в рабочее
												время формирует и передает Поставщику через Личный кабинет оформленную
												заявку, содержащую контактные данные клиента и предварительные параметры
												запроса, для дальнейшей детальной обработки (окончательного
												подтверждения деталей, специфичных технических консультаций,
												согласования точного времени и итоговой стоимости).
											</li>
										</ol>
									</p>
									<p>
										<b>3.1.4.</b> <b>Цель установленного порядка:</b> минимизация потерь
										потенциальных клиентов из-за пропущенных звонков, отсутствия ответа в нерабочее
										время Поставщика, недостаточной квалификации персонала на первичном этапе, а
										также обеспечение базового контроля качества и единого стандарта первичной
										коммуникации со стороны Сервиса.
									</p>
									<p>
										<b>3.2.</b> <b>Порядок для тарифа «Premium» (подписка).</b>
									</p>
									<p>
										<b>3.2.1.</b> Поставщикам на тарифе <b>«Premium»</b> предоставляется право на
										прямое размещение своих контактных данных (телефон, электронная почта, ссылки на
										мессенджеры и социальные сети) в публичном профиле на Сайте.
									</p>
									<p>
										<b>3.2.2.</b> Клиенты связываются с Поставщиком на тарифе «Premium»{' '}
										<b>напрямую</b>, используя опубликованные контакты.
									</p>
									<p>
										<b>3.2.3.</b> Обработка таких прямых заявок, вся дальнейшая коммуникация,
										консультирование, подтверждение бронирования и согласование условий
										осуществляется Поставщиком <b>самостоятельно и в полном объеме</b>, с
										обязательным соблюдением общих стандартов работы, установленных разделом 3
										настоящих Правил.
									</p>

									<p>
										<b>3.3.</b> <b>Ответственность, переход между тарифами и аналитика.</b>
									</p>
									<p>
										<b>3.3.1.</b> Регистрируясь на Сервисе и начиная сотрудничество на тарифе «PRO»,
										Поставщик безоговорочно принимает и соглашается с установленным в пункте 3.1
										порядком первичной коммуникации, признавая его целесообразность и обязуясь
										оперативно обрабатывать передаваемые Оператором заявки.
									</p>
									<p>
										<b>3.3.2.</b> Если для Поставщика является критически важным получение первичных
										звонков и обращений от клиентов напрямую, без посредничества контакт-центра
										Оператора, Поставщику рекомендуется <b>перейти на тариф «Premium»</b>, условия
										которого изложены в пункте 3.2.
									</p>
									<p>
										<b>3.3.3.</b> Оператор оставляет за собой право собирать и использовать
										обезличенные аналитические данные о количестве входящих обращений, частоте
										пропущенных звонков (в рамках работы контакт-центра) и общих метриках
										эффективности обработки заявок в целях улучшения работы платформы, оптимизации
										процессов и повышения общей конверсии. Такие данные не содержат персональной
										информации клиентов или коммерческой тайны Поставщиков.
									</p>
									<p>
										<b>3.4.</b> Для Поставщиков на тарифе <b>«PRO»</b> установлен следующий{' '}
										<b>обязательный порядок обработки каждого нового Заказа</b>, поступившего через
										Сервис:
									</p>
									<p>
										<b>3.4.1.</b> <b>Этап 1. Получение и оперативный контакт.</b>
										<br />
										Поставщик отслеживает появление новых Заказов в Личном кабинете (ЛК).
										<br />
										Рекомендуется использовать все доступные средства оповещения (email-уведомления,
										push-уведомления мобильного приложения, подключение Telegram-бота для интеграции
										с ЛК). Уполномоченный менеджер Поставщика обязан в течение{' '}
										<b>1 (одного) часа в рабочее время</b> (или в первый час следующего рабочего
										дня, если заявка поступила в нерабочее время) связаться с Заказчиком по
										указанным в заявке контактам (телефон, Telegram, email) для подтверждения
										получения заявки.
									</p>
									<p>
										<b>3.4.2.</b> <b>Этап 2. Консультация и подтверждение.</b>
										<br />
										Менеджер Поставщика проводит консультацию, уточняет детали потребностей
										Заказчика, согласовывает возможные дополнительные услуги, уточняет время и дату.
										<br />
										<b>Цель этапа</b> — получить от Заказчика четкое, недвусмысленное подтверждение
										его намерения осуществить бронирование на конкретных условиях.
									</p>
									<p>
										<b>3.4.3.</b> <b>Этап 3. Фиксация результата и обратная связь с Оператором.</b>
										<br />
										После подтверждения Заказчиком, Поставщик обязан немедленно направить менеджеру
										Оператора обратную связь, содержащую три ключевых элемента:
										<ol type='a'>
											<li>
												<b>Факт:</b> «Клиент подтвердил бронирование».
											</li>
											<li>
												<b>Параметры:</b> Актуальные дата и время.
											</li>
											<li>
												<b>Финансы:</b> Итоговая сумма Заказа с учетом всех согласованных
												дополнительных услуг.
											</li>
										</ol>
										<u>Важно:</u> Сообщение об изменении итоговой суммы является критически важным
										для корректного расчета агентского вознаграждения Оператора (20% от финальной
										суммы).
										<br />
										Непредоставление этой информации или ее сокрытие рассматривается как нарушение
										финансовой дисциплины.
									</p>
									<p>
										<b>3.4.4.</b> <b>Этап 4. Обновление статуса в Личном кабинете (ЛК).</b>
										<br />
										На основании проделанной работы менеджер Поставщика обязан вручную обновить
										статус Заказа в ЛК:
										<ul>
											<li>
												<b>«Подтвержден»</b> — сразу после завершения Этапа 3.
											</li>
											<li>
												<b>«Завершен»</b> — после оказания услуги и проведения расчетов с
												Заказчиком.
											</li>
											<li>
												<b>«Отменен»</b> — если сделка не состоялась, с кратким указанием
												причины в комментарии.
											</li>
										</ul>
									</p>
									<p>
										<b>3.4.5.</b> <b>Ответственность за соблюдение алгоритма.</b>
										<br />
										Соблюдение данного алгоритма является обязательным условием для Поставщиков на
										тарифах «PRO».
										<br />
										Несоблюдение этапов, особенно касающихся сроков связи с клиентом и
										предоставления финальной финансовой информации Оператору, может привести к
										применению санкций, включая штрафы за срыв коммуникации, перерасчет комиссии в
										двойном размере, а в случае систематических нарушений — к расторжению Договора.
									</p>
									<p>
										<b>3.5.</b> <b>Информирование об изменениях.</b>
										<br />
										Любые изменения параметров подтвержденного Заказа (перенос даты/времени,
										изменение состава услуг, корректировка итоговой стоимости) должны быть
										незамедлительно внесены Поставщиком в Личный кабинет и в обязательном порядке
										доведены до сведения ответственного менеджера Оператора через согласованный
										канал связи (электронная почта, мессенджер, указанный в профиле).
									</p>
									<p>
										<b>3.6.</b> <b>Обязанности Поставщика на тарифе «Premium» (подписка).</b>
									</p>
									<p>
										<b>3.6.1.</b> <b>Обязательное обновление статусов в ЛК.</b> Поставщик на тарифе
										«Premium» обязан отслеживать поступление Заказов и вручную изменять их статусы в
										Личном кабинете:
										<ul>
											<li>
												<b>«Подтвержден»</b> — после согласования всех деталей и получения
												подтверждения от Заказчика.
											</li>
											<li>
												<b>«Завершен»</b> — после оказания услуги и проведения расчетов с
												Заказчиком.
											</li>
											<li>
												<b>«Отменен»</b> — если сделка не состоялась, с кратким указанием
												причины в комментарии.
											</li>
										</ul>
									</p>
									<p>
										<b>3.7.</b> <b>Общие принципы и санкции за нарушения отчетности.</b>
									</p>
									<p>
										<b>3.7.1.</b> <b>Принцип добросовестного информирования.</b> Предоставление
										Оператору полной, точной и своевременной информации, в особенности об итоговой
										финансовой стороне Заказов (для тарифа «PRO») и об изменениях (для всех
										тарифов), является существенным условием Договора и свидетельством
										добросовестности Поставщика.
									</p>
									<p>
										<b>3.7.2.</b> <b>Меры воздействия за нарушения.</b> В случае сокрытия
										информации, предоставления недостоверных данных или систематического
										несоблюдения процедур, установленных настоящим разделом, Оператор вправе
										применить к Поставщику следующие меры, исходя из тяжести и частоты нарушений:
										<ol type='a'>
											<li>
												<b>a) Оперативные меры:</b>
												Понижение тарифного плана (например, принудительный перевод с «Premium»
												на «PRO» с соответствующим изменением порядка расчетов); временное
												скрытие карточки Поставщика из результатов поиска и каталога Сервиса
												(понижение в выдаче).
											</li>
											<li>
												<b>b) Крайняя мера:</b> В случае грубого или систематического нарушения
												— одностороннее внесудебное расторжение Договора и удаление карточки
												Поставщика из каталога Сервиса без возврата каких-либо средств.
											</li>
										</ol>
									</p>
									<p>
										<b>3.7.3.</b> Применение указанных мер не освобождает Поставщика от обязанности
										уплатить причитающееся Оператору агентское вознаграждение, а также штрафные
										санкции, предусмотренные Договором.
									</p>
									<p>
										<b>3.8.</b> <b>Процедура действий при невозможности исполнения Заказа:</b>
									</p>
									<p>
										<b>3.8.1.</b> В случае возникновения обстоятельств, делающих невозможным
										исполнение ранее подтвержденного Заказа (внезапная поломка оборудования,
										закрытие Зала, форс-мажор), Поставщик обязан:
										<ul>
											<li>
												уведомить об этом Оператора немедленно после обнаружения таких
												обстоятельств;
											</li>
											<li>
												но не позднее чем за <b>24 (двадцать четыре) часа</b> до
												запланированного времени начала оказания услуг.
											</li>
										</ul>
									</p>
									<p>
										<b>3.8.2.</b> Поставщику запрещается предпринимать самостоятельные действия по
										передаче Заказчика и его данных (контактной информации, параметров заказа)
										другим поставщикам или третьим лицам. Задачу по поиску альтернативного Зала и
										организации переноса бронирования в полном объеме берет на себя Оператор через
										внутренние процедуры Сервиса.
									</p>
									<p>
										<b>4. ФИНАНСОВАЯ И ОТЧЕТНАЯ ДИСЦИПЛИНА</b>
									</p>
									<p>
										<b>4.1.</b> <b>Детализация порядка расчетов.</b>
									</p>
									<p>
										<b>4.1.1.</b> Вознаграждение Поставщика за оказанные услуги (полная стоимость
										Заказа за вычетом суммы агентского вознаграждения Оператора) подлежит
										перечислению Оператором на расчетные реквизиты Поставщика{' '}
										<b>в течение 2 (двух) рабочих дней</b>, следующих за календарной датой оказания
										услуги Заказчику (датой, соответствующей дню бронирования).
										<br />
										Указанный срок применяется при условии, что оплата от Заказчика была получена
										Оператором через систему онлайн-оплаты Сервиса.
									</p>
									<p>
										<b>4.1.2.</b> По письменной заявке Поставщика, направленной на официальный адрес
										электронной почты Оператора и подтвержденной его персональным менеджером, между
										Сторонами может быть установлен иной, периодический порядок взаиморасчетов:
										<ol type='a'>
											<li>
												<b>a) Еженедельный:</b> Консолидированная выплата производится каждый
												понедельник (или в первый рабочий день недели) за все Заказы, которые
												были завершены в течение предыдущей календарной недели (с понедельника
												по воскресенье).
											</li>
											<li>
												<b>b) Раз в две недели:</b> Выплаты производятся по согласованному и
												зафиксированному в переписке графику (например, каждую вторую и
												четвертую пятницу месяца).
											</li>
										</ol>
									</p>
									<p>
										<b>4.2.</b>{' '}
										<b>Специальные условия перехода с тарифа «PRO» на тариф «Premium».</b>
										<br />
										Переход Поставщика с тарифного плана <b>«PRO»</b> на тарифный план{' '}
										<b>«Premium»</b> допускается исключительно после полного погашения всей
										имеющейся задолженности перед Оператором по агентскому вознаграждению,
										начисленному за все Заказы, совершенные и завершенные в период действия тарифа
										«PRO».
										<br />
										Оплата абонентской платы за новый период по тарифу «Premium»{' '}
										<u>не подлежит зачету</u> в счет погашения указанной задолженности по агентскому
										вознаграждению.
										<br />
										Переход осуществляется только после письменного (в том числе в форме
										электронного сообщения) подтверждения менеджером Оператора отсутствия
										задолженности.
									</p>
									<p>
										<b>4.3.</b> <b>Уведомление о приостановке или прекращении деятельности:</b>
										<br />В случае принятия решения о временной приостановке или полном прекращении
										деятельности Зала Поставщик обязан направить Оператору официальное письменное
										уведомление <b>не менее чем за 5 (пять) рабочих дней</b> до даты
										приостановки/закрытия.
										<br />
										До указанной даты Поставщик остается ответственным за исполнение всех ранее
										подтвержденных Заказов.
									</p>
									<p>
										<b>4.4.</b> Датой выполнения Поставщиком обязательства по перечислению денежных
										средств Оператору считается дата списания денежных средств с расчётного счёта
										Поставщика в адрес Оператора.
									</p>
									<p>
										<b>4.5.</b> Размещение рекламных материалов на Сайте и связанных с ним страницах
										в социальных сетях, оплачивается отдельно согласно согласованным Сторонами
										расценкам.
									</p>
									<p>
										<b>4.6.</b> Стороны соглашаются, что выставление, направление, получение,
										подписание и обмен финансовыми документами (счёт, акты выполненных работ, акты
										сверок и пр.) между Сторонами осуществляется посредством обмена электронными
										документами через Личный кабинет или по электронной почте.
										<br />
										Подготовка и предоставление указанных документов на бумажном носителе,
										осуществляется по отдельному запросу одной из Сторон.
									</p>
									<p>
										<b>4.7.</b> <b>Порядок актирования и сверки.</b>
									</p>
									<p>
										<b>4.7.1.</b> Оператор формирует и размещает в Личном кабинете Поставщика{' '}
										<b>ежемесячный отчет</b>, содержащий данные обо всех Заказах, расчетах,
										удержанном агентском вознаграждении и перечисленных суммах за истекший
										календарный месяц.
										<br />
										Указанный отчет обладает юридической силой{' '}
										<b>Акта сдачи-приемки оказанных услуг</b>.
									</p>
									<p>
										<b>4.7.2.</b> Поставщик обязан провести сверку данных, указанных в отчете, в
										срок <b>не позднее 10 (десяти) рабочих дней</b> с даты его размещения в Личном
										кабинете.
									</p>
									<p>
										<b>4.7.3.</b> При отсутствии мотивированных письменных возражений Поставщика,
										направленных Оператору с соблюдением процедуры, установленной Договором, по
										истечении указанного <b>10-дневного срока (рабочие дни)</b> отчет считается
										согласованным, а услуги Оператора за соответствующий период — принятыми
										Поставщиком в полном объеме и надлежащего качества.
									</p>
									<p>
										<b>4.8.</b> За <b>каждое Бронирование</b>, а также платную отмену Бронирования
										(отмену Бронирования с удержанием части или полной цены Договора), Поставщик
										обязуется выплатить Оператору агентское вознаграждение (на тарифе «PRO»).
									</p>
									<p>
										<b>4.8.1.</b> Агентское вознаграждение <u>не выплачивается</u> в случае, если
										Заказчиком была совершена <b>бесплатная отмена Бронирования</b> в соответствии с
										Пользовательским соглашением.
										<br />
										Отмена Бронирования Поставщиком влечет штрафные санкции, предусмотренные п. 6.4.
										Правил.
									</p>
									<p>
										<b>4.8.2.</b> Размер агентского вознаграждения определяется согласно
										представленным в <b>Приложении №2 Тарифам Оператора</b>.<br />
										Для целей расчета вознаграждения учитывается <b>полная стоимость Заказа</b>,
										включая все дополнительные услуги, оказанные Поставщиком Заказчику в рамках
										забронированного времени.
									</p>
									<p>
										<b>4.8.3.</b> Цена Договора, предлагаемая на Сайте, включает в себя стоимость
										Услуг Поставщика, все налоги и сборы, а также агентское вознаграждение
										Оператора, куда включаются также комиссии платежной системы.
									</p>
									<p>
										<b>4.8.4.</b> При перечислении Поставщику денежных средств Оператор удерживает
										агентское вознаграждение в размере, указанном в Договоре с Поставщиком.
									</p>
									<p>
										<b>4.9.</b> Дополнительные услуги предоставляются Оператором по запросу
										Поставщика услуг и оплачиваются Поставщиком дополнительно.
									</p>
									<p>
										<b>4.10.</b> В случае бронирования Услуги Поставщика, при использовании им
										тарифа <b>«PRO»</b>, через Сайт Оператора <b>без внесения предоплаты</b> и
										осуществление расчетов по факту оказания Услуг непосредственно с Поставщиком,
										Поставщик обязуется выплатить комиссию Оператору согласно Тарифу{' '}
										<b>в течение 5 (пяти) рабочих дней</b> с момента оказания Услуги Заказчику (для
										целей договора днем оказания услуги является выбранная Заказчиком дата
										бронирования на сайте, если иное не будет доказано Поставщиком).
									</p>
									<p>
										<b>4.11.</b> <b>Пробный период и автопродление:</b>
									</p>
									<p>
										<b>4.11.1.</b> Оператор вправе предоставить новым Поставщикам услуг{' '}
										<b>Пробный период</b> использования Сервиса. Пробный период исчисляется с даты
										верификации банковской карты Поставщика в Сервисе, т.е. получения Оператором
										подтверждения платежей в соответствии с предоставленными данными.
										<br />
										Для целей Соглашения <b>новым</b> считается Поставщик, использующий новый
										логин/номер телефона.
									</p>
									<p>
										<b>4.11.2.</b> Продолжительность Пробного периода определяется Оператором
										самостоятельно. Точный срок Пробного периода указывается на станице регистрации
										Поставщика услуг.
									</p>
									<p>
										<b>4.11.3.</b> При предоставлении Пробного периода Оператор самостоятельно
										определяет объем доступного Поставщику функционала Сервиса и период его
										доступности.
									</p>
									<p>
										<b>4.11.4.</b> Оператор в рамках проведения маркетинговых мероприятий (рекламных
										акций и т.д.) вправе предоставить Поставщику услуг на время проведения таких
										мероприятий Пробный период к Сервису. При этом Оператор самостоятельно
										определяет объем функционала Сервиса, доступ к которому предоставляется в рамках
										указанных мероприятий, а также иные условия получения такого доступа Поставщиком
										(например, Регистрация в Сервисе или совершение иных действий Поставщиком).
									</p>
									<p>
										<b>4.11.5.</b> При получении и оформлении Пробного периода доступа к Сервису
										автоматически подключается <b>Автопродление</b>.
									</p>
									<p>
										<b>4.11.6.</b> Поставщик услуг вправе отключить Автопродление в любое время
										через Личный кабинет.
										<br />
										При отключении Автопродления возможно сокращение срока действия Пробного
										периода.
									</p>
									<p>
										<b>4.11.7.</b> Автопродление по Тарифу осуществляется посредством
										автоматического списания денежных средств с банковского счета Поставщика услуг
										согласно правилам и условиям банка и/или платежной системы, при условии наличия
										денежных средств на таком счете.
									</p>
									<p>
										<b>4.11.8.</b> Поставщик услуг соглашается на договорное списание денежных
										средств его обслуживающим банком с его банковского счета по окончании пробного
										периода при оформлении Тарифа.
									</p>
									<p>
										<b>4.11.9.</b> В случае отсутствия средств на банковском счете Поставщика на
										момент осуществления автоматического списания, автоматическое списание может
										быть повторено до момента успешного списания средств в срок{' '}
										<b>до 60 (шестидесяти) календарных дней</b> с момента первой попытки такого
										автоматического списания.
									</p>
									<p>
										<b>4.11.10.</b> Выбранный Поставщиком Тариф оформляется <b>бессрочно</b> с
										момента оплаты первого Тарифного плана с использованием банковской карты на
										условиях Автопродления.
										<br />
										Количество пролонгаций Тарифа Договора не ограничено.
									</p>
									<p>
										<b>4.12.</b> <b>Условия изменения Тарифа, отказ от Тарифа</b>
									</p>
									<p>
										<b>4.12.1.</b> <b>Условия для тарифа «PRO».</b>
									</p>
									<p>
										<b>4.12.1.1.</b> Сотрудничество на тарифе «PRO» не ограничено каким-либо
										предоплаченным сроком и действует на бессрочной основе, если иное не установлено
										Договором. Основным финансовым обязательством Поставщика является уплата
										агентского вознаграждения (комиссии) за каждый успешно завершенный Заказ в
										размере, установленном Приложением №2 к Договору.
									</p>
									<p>
										<b>4.12.1.2.</b> Поставщик вправе в любой момент прекратить использование
										Сервиса и расторгнуть Договор, направив Оператору соответствующее письменное
										уведомление через Личный кабинет или на адрес электронной почты{' '}
										<a href='mailto:info@podcastbery.ru'>info@podcastbery.ru</a>. Доступ к Личному
										кабинету и каталогу прекращается в течение 5 (пяти) рабочих дней с момента
										получения уведомления Оператором.
									</p>
									<p>
										<b>4.12.1.3.</b> Поскольку абонентская плата за доступ к Сервису на тарифе «PRO»
										не взимается, вопрос о возврате каких-либо денежных средств Поставщику не
										возникает. Все финансовые взаимоотношения сторон по данному тарифу исчерпываются
										обязательствами Поставщика по выплате комиссии за фактически выполненные и
										оплаченные Заказчиком Заказы.
									</p>
									<p>
										<b>4.12.2.</b> <b>Условия для тарифа «Premium».</b>
									</p>
									<p>
										<b>4.12.2.1.</b> Доступ к расширенному функционалу на тарифе «Premium»
										предоставляется на условиях <b>стопроцентной предоплаты</b> абонентской платы за
										выбранный расчетный период (месяц, квартал, год).
									</p>
									<p>
										<b>4.12.2.2.</b> <b>Возврат средств при досрочном отказе от тарифа:</b>
										<ul>
											<li>
												В случае добровольного отказа Поставщика от тарифа «Premium» до
												истечения оплаченного периода, Поставщик вправе обратиться к Оператору с
												заявлением о возврате части уплаченной абонентской платы.
											</li>
											<li>
												Возврату подлежит сумма, рассчитанная{' '}
												<b>пропорционально неиспользованному времени</b> текущего оплаченного
												периода, за вычетом фактически понесенных Оператором расходов.
												Конкретный порядок пропорционального расчета (шкала возврата) определен
												в пункте 4.12.2.3. Правил.
											</li>
											<li>
												<b>Исключение:</b> для тарифа «Premium» с минимальным расчетным периодом
												в <b>30 (тридцать) дней</b> действует особое условие, согласно которому
												оплата, внесенная за данный период, возврату не подлежит ни при каких
												обстоятельствах досрочного прекращения доступа.
											</li>
										</ul>
									</p>
									<p>
										<b>4.12.2.3.</b> Порядок пропорционального расчета (шкала возврата): <br />
										<br />
										для Тарифов, рассчитанных на 182 дня
									</p>
									<table>
										<tr>
											<th>День использования Тарифа, в который происходит отказ</th>
											<th>Часть стоимости Тарифа, подлежащая возврату</th>
										</tr>
										<tr>
											<td>1-30</td>
											<td>84%</td>
										</tr>
										<tr>
											<td>31-60</td>
											<td>67%</td>
										</tr>
										<tr>
											<td>61-90</td>
											<td>50%</td>
										</tr>
										<tr>
											<td>91-120</td>
											<td>34%</td>
										</tr>
										<tr>
											<td>121-150</td>
											<td>17%</td>
										</tr>
										<tr>
											<td>151 и более</td>
											<td>0%</td>
										</tr>
									</table>
									<br />
									<p>для Тарифов, рассчитанных на 365 дней</p>
									<table>
										<tr>
											<th>День использования Тарифа, в который происходит отказ</th>
											<th>Часть стоимости Тарифа, подлежащая возврату</th>
										</tr>
										<tr>
											<td>1-30</td>
											<td>92%</td>
										</tr>
										<tr>
											<td>31-60</td>
											<td>84%</td>
										</tr>
										<tr>
											<td>61-90</td>
											<td>75%</td>
										</tr>
										<tr>
											<td>91-120</td>
											<td>67%</td>
										</tr>
										<tr>
											<td>121-150</td>
											<td>59%</td>
										</tr>
										<tr>
											<td>151-180</td>
											<td>50%</td>
										</tr>
										<tr>
											<td>181-210</td>
											<td>42%</td>
										</tr>
										<tr>
											<td>211-240</td>
											<td>34%</td>
										</tr>
										<tr>
											<td>241-270</td>
											<td>25%</td>
										</tr>
										<tr>
											<td>271-300</td>
											<td>17%</td>
										</tr>
										<tr>
											<td>301-330</td>
											<td>9%</td>
										</tr>
										<tr>
											<td>331 и более</td>
											<td>0%</td>
										</tr>
									</table>
									<br />
									<p>
										<b>4.13. Отказ от Автопродления.</b> Для предотвращения автоматического списания
										средств за следующий расчетный период Поставщик обязан самостоятельно отключить
										функцию «Автопродление» в настройках Личного кабинета или направить
										соответствующее заявление Оператору{' '}
										<b>не позднее чем за 24 (двадцать четыре) часа</b> до даты планируемого
										автоматического списания.
									</p>

									<p>
										<b>4.14. Расторжение по инициативе Оператора.</b> В случае расторжения Договора
										Оператором в одностороннем внесудебном порядке по основаниям, предусмотренным
										Договором (в том числе, но не ограничиваясь, грубыми нарушениями, указанными в
										разделе 5 и 6 настоящих Правил), абонентская плата, уплаченная Поставщиком за
										неистекший период действия тарифа «Premium», <u>возврату не подлежит</u>.
									</p>

									<p>
										<b>4.15.</b> Обязательства Оператора по предоставлению Поставщику доступа к
										Сервису считаются исполненными перед Поставщиком независимо от того, было ли
										затребовано Поставщиком соответствующее исполнение от Оператора в Период
										действия Тарифа, а также независимо от фактического количества и объема
										оказанных Поставщику Услуг в рамках действия Тарифа.
									</p>

									<p>
										<b>4.16.</b> Стоимость Тарифа, уплаченная Поставщиком, не пересчитывается и не
										возвращается Поставщику если Поставщик в течение оплаченного периода действия
										Тарифа не воспользовался Сервисами Оператора или использовал такое право в
										неполном объеме.
									</p>

									<p>
										<b>5. ПРАВА И ОБЯЗАННОСТИ СТОРОН</b>
									</p>

									<p>
										<b>5.1.</b> <b>Поставщик услуг обязуется:</b>
									</p>
									<p>
										<b>5.1.1.</b> размещать актуальную и достоверную информацию в соответствующих
										полях в Личном кабинете на Сайте, соблюдая правила размещения информации и
										изображений и условия пользовательского соглашения, а именно:
									</p>

									<p>
										<b>5.1.1.1.</b> не размещать недостоверную информацию;
									</p>
									<p>
										<b>5.1.1.2.</b> не размещать изображения, содержащие эротику;
									</p>
									<p>
										<b>5.1.1.3.</b> не размещать изображения, которые не отражают индивидуальность
										помещения Поставщика услуг, которые могут ввести пользователей в заблуждение, т.
										е. такие изображения, которые не дают пользователю представления о самой
										Зале, либо об иных оказываемых им услугах;
									</p>
									<p>
										<b>5.1.1.4.</b> не размещать в описании Услуг гиперссылки;
									</p>

									<p>
										<b>5.1.2.</b> если это предусмотрено Тарифом — самостоятельно и своевременно
										обновлять информацию и цены на свои Услуги в Личном кабинете на Сайте, при этом
										цены при бронировании Услуг через Сайт <u>не должны превышать</u> цены при
										бронировании непосредственно через Поставщика услуг или третьих лиц;
									</p>

									<p>
										<b>5.1.3.</b> отслеживать поступающие в автоматизированном режиме заказы от
										Заказчиков и обеспечивать их своевременное и надлежащее выполнение;
									</p>

									<p>
										<b>5.1.4.</b> предоставлять услуги Заказчикам, привлечённым Оператором и
										осуществившим заказ услуг Поставщика услуг, в соответствии с Правилами Сайта;
									</p>

									<p>
										<b>5.1.5.</b> принять от Оператора все исполненное им в соответствии с условиями
										настоящего Договора;
									</p>

									<p>
										<b>5.1.6.</b> систематически осуществлять проверку Личного кабинета на Сайте,
										адреса электронной почты, указанного при регистрации на сайте, а также указанных
										реквизитов. В случае изменения банковских реквизитов Поставщик услуг обязуется
										незамедлительно уведомить об этом Оператора;
									</p>

									<p>
										<b>5.1.7.</b> при необходимости вносить актуальные изменения в Описание и
										правила бронирования, связанные с особенностью оказываемых Услуг.
									</p>

									<p>
										<b>5.1.8.</b> не использовать роботы, программы-обходчики, боты и иные
										автоматизированные средства или процессы для сбора данных или другого контента,
										а также для доступа к ним и совершения иных действий на Сайте вне зависимости от
										целей;
									</p>

									<p>
										<b>5.1.9.</b> не предпринимать какие-либо действия, которые наносят ущерб и/или
										негативно влияют на работоспособность Сайта, а также могут нанести ущерб или
										негативно повлиять на надлежащее функционирование Сайта.
									</p>

									<p>
										<b>5.1.10.</b> При тарифе «PRO» — незамедлительно и в обязательном порядке
										обновлять статусы всех поступающих Заказов в Личном кабинете («подтвержден»,
										«отклонен», «завершен»), а также оперативно информировать Оператора через Личный
										кабинет или согласованный канал связи обо всех изменениях в Заказе (дата, время,
										состав услуг, итоговая стоимость), в том числе после его завершения.
									</p>

									<p>
										<b>5.1.11.</b> В течение 7 (семи) календарных дней с момента регистрации на
										Сервисе полностью заполнить карточку своего Зала (Студии) актуальной и
										достоверной информацией, включая описание, фотографии, перечень услуг,
										прайс-лист и правила бронирования. В случае неисполнения данного обязательства
										Оператор вправе удалить или заблокировать аккаунт Поставщика.
									</p>

									<p>
										<b>5.1.12.</b> Поддерживать всю информацию в Личном кабинете в актуальном
										состоянии и незамедлительно вносить изменения при их возникновении (включая
										изменение цен, графика работы, состава услуг, закрытие Студии). В случае
										закрытия Зала (Студии) уведомить Оператора не менее чем за 5 (пять) рабочих
										дней.
									</p>

									<p>
										<b>5.1.13.</b> При невозможности выполнить подтвержденный Заказ (занятость,
										закрытие и т.п.) незамедлительно уведомить об этом Оператора для передачи
										Заказчика другой студии-партнеру. Самостоятельная передача данных Заказчика
										третьим лицам запрещена.
									</p>

									<p>
										<b>5.1.14.</b> После оказания Услуги рекомендовать Заказчику оставить отзыв о
										работе Поставщика на Сайте Оператора.
									</p>

									<p>
										<b>5.2.</b> <b>Поставщик услуг имеет право:</b>
									</p>
									<p>
										<b>5.2.1.</b> получать оперативную информацию о поступающих заказах и
										бронированиях;
									</p>
									<p>
										<b>5.2.2.</b> получать консультации по работе сервиса в рабочее время в будние
										дни;
									</p>
									<p>
										<b>5.2.3.</b> получать дополнительные услуги согласно расценкам, установленным
										Оператором;
									</p>

									<p>
										<b>5.3.</b> Загружая фотографии/изображения на Сайт, Поставщик услуг
										подтверждает и гарантирует, что является обладателем авторских прав на эти
										фотографии/изображения и даёт свое согласие на использование Оператором
										загруженных фотографий/изображений на Сайте, в рекламных материалах и
										публикациях, размещённых онлайн и офлайн, а также любым другим образом на
										усмотрение Оператора. <br />
										Поставщик услуг предоставляет Оператору неисключительное, действующее во всём
										мире, безотзывное, безусловное и бессрочное право и разрешение на использование,
										воспроизведение, отображение, копирование, распространение, лицензирование,
										передачу и размещение фотографий/изображений любым способом по усмотрению
										Оператора. <br /> Загружая фотографии/изображения, Поставщик услуг принимает на
										себя полную ответственность за достоверность, действительность и право на
										использование всех фотографий/изображений, за претензии юридического характера
										со стороны третьих лиц, в связи с публикациями и использованием Оператором этих
										фотографий/изображений. <br /> Поставщик услуг гарантирует, что
										фотографии/изображения не содержат вирусы, троянские программы или файлы,
										заражённые вирусами, а также не содержат никаких порнографических, незаконных,
										непристойных, оскорбительных, неприемлемых или неуместных материалов и не
										нарушают права третьих лиц, в том числе право интеллектуальной собственности,
										авторские права или право на неприкосновенность частной жизни.
									</p>

									<p>
										<b>5.4.</b> При наличии технической возможности Сайта в актуальной версии, при
										соответствующем Тарифе Оператор предоставляет возможность Поставщику услуг
										использовать внутреннюю систему управления взаимоотношениями с Заказчиками,
										направленную на автоматизацию стратегий взаимодействия с Заказчиками, в
										частности, для повышения уровня продаж, оптимизации маркетинга и улучшения
										обслуживания клиентов путём сохранения информации о Заказчиках и истории
										взаимоотношений с ними, установления и улучшения бизнес-процессов и последующего
										анализа результатов.
									</p>

									<p>
										<b>5.5.</b> <b>Оператор обязуется:</b>
									</p>
									<p>
										<b>5.5.1.</b> размещать в открытом доступе на Сайте информацию, предоставленную
										Поставщиком услуг в Личном кабинете на Сайте;
									</p>
									<p>
										<b>5.5.2.</b> обеспечить доступ Поставщика услуг к информации, о текущем
										выполнении обязательств Оператора по отношению к Поставщику услуг;
									</p>
									<p>
										<b>5.5.3.</b> принимать заявки на устранение ошибок и устранять их в разумные
										сроки;
									</p>
									<p>
										<b>5.5.4.</b> за свой счёт поддерживать работу Сайта;
									</p>
									<p>
										<b>5.5.5.</b> осуществлять проверку адреса электронной почты 
										<a href='mailto:info@podcastbery.ru'>info@podcastbery.ru</a>.
									</p>

									<p>
										<b>5.6.</b> <b>Оператор имеет право:</b>
									</p>
									<p>
										<b>5.6.1.</b> посещать Зал Поставщика услуг в рабочее время и проверять
										соответствие заявленных характеристик фактически существующим;
									</p>
									<p>
										<b>5.6.2.</b> самостоятельно изменять или заблокировать информацию, размещённую
										на Сайте, которая не соответствует правилам размещения информации;
									</p>
									<p>
										<b>5.6.3.</b> приостановить доступ к Личному кабинету, в случае обнаружения
										подозрительной активности, в частности при обнаружении попыток целенаправленного
										использования сервиса против интересов Оператора или иных третьих лиц, уведомив
										об этом контактное лицо со стороны Поставщика услуг;
									</p>
									<p>
										<b>5.6.4.</b> менять условия Тарифа в одностороннем порядке;
									</p>
									<p>
										<b>5.6.5.</b> проводить поощрительные мероприятия, направленные на повышение
										активности Поставщика услуг;
									</p>
									<p>
										<b>5.6.6.</b> удалять информацию, фотографии/изображения, которые не
										соответствуют п.п. 5.1.1, 5.3 Правил, в любое время и без предварительного
										уведомления Поставщика услуг.
									</p>
									<p>
										<b>5.6.7.</b> На тарифе «PRO» не публиковать прямой телефон Поставщика,
										используя для связи с Заказчиками выделенный номер телефона менеджера Оператора,
										который осуществляет первичную обработку запроса и его передачу Поставщику.
									</p>
									<p>
										<b>5.6.8.</b> До публикации карточки Поставщика в общем каталоге проводить
										проверку предоставленных данных (включая данные юридического лица/ИП) на
										достоверность и соответствие требованиям Сервиса. В случае выявления
										несоответствий или предоставления недостоверных данных отказать в публикации или
										удалить карточку.
									</p>

									<p>
										<b>6. ОТВЕТСТВЕННОСТЬ СТОРОН</b>
									</p>

									<p>
										<b>6.1.</b> В случае непредставления Поставщиком услуг Заказчику Зала в
										забронированные часы (в том числе при наложении броней по вине Поставщика услуг
										при несвоевременном/некорректном внесении данных о бронях), Поставщик
										выплачивает Оператору штраф в размере <b>1 000 (одна тысяча) рублей</b> за
										каждый обнаруженный случай.
										<br />
										Оператор также вправе удержать сумму штрафа от полной суммы внесённой
										Поставщиком предоплаты по Тарифу, уменьшив сроки оказываемой услуги по Тарифу
										соразмерно размеру удержанного штрафа.
										<br />
										Оператор вправе заблокировать аккаунт Поставщика услуг до момента погашения
										выставленного штрафа.
									</p>

									<p>
										<b>6.1.1.</b> В случае срыва подтвержденного Заказа по вине Поставщика (в том
										числе указанные в п. 5.1.13 обстоятельства), Поставщик помимо уплаты штрафа,
										предусмотренного п. 6.1, обязан выплатить Оператору агентское вознаграждение{' '}
										<b>в полном размере</b>, как если бы Заказ был выполнен.
									</p>

									<p>
										<b>6.2.</b> В случае нарушения Поставщиком услуг правил размещения информации на
										Сайте, Оператор оставляет за собой право приостановить доступ к Сайту, до
										устранения нарушений.
									</p>

									<p>
										<b>6.3.</b> В случае нарушения Поставщиком услуг условия о цене, указанного в п.
										5.1.2 Правил, Поставщик услуг уплачивает Оператору штраф:
									</p>
									<ul>
										<li>
											в размере <b>1 000 (одна тысяча) рублей</b>, в случае обнаружения Оператором
											факта нарушения.
										</li>
									</ul>
									<p>
										Оператор вправе удерживать сумму указанных штрафов от полной суммы внесённой
										Поставщиком предоплаты по Тарифу, уменьшив сроки оказываемой услуги по Тарифу
										соразмерно размеру удержанного штрафа.
										<br />
										Оператор вправе заблокировать аккаунт Поставщика услуг до момента погашения
										выставленного штрафа.
									</p>

									<p>
										<b>6.4.</b> В случае отмены Поставщиком услуг Заказа, поступившего через Сайт
										Оператора, без реального намерения аннулировать такой Заказ, Оператор оставляет
										за собой право взыскать с Поставщика услуг фактически понесённые Оператором
										расходы, а также штраф в размере платы по Тарифу.
									</p>

									<p>
										<b>6.5.</b> Оператор несёт перед Поставщиком услуг ответственность в случае
										полной или частичной неработоспособности системы или ее компонентов в течение
										какого-либо времени при отсутствии возможности доступа Поставщика услуг к
										Личному кабинету за сорванные в связи с такими событиями бронированиями в
										размере,{' '}
										<u>
											не превышающем агентское вознаграждение за сорванные бронирования по вине
											Оператора
										</u>
										, при наличии причинно-следственной связи.
									</p>

									<p>
										<b>6.6.</b> Штрафные санкции, предусмотренные п. 6.5 Правил, подлежат применению
										в случае направления Стороной, чьи права нарушены, другой Стороне письменного
										требования, подписанного уполномоченным представителем такой Стороны.
										<br />
										При отсутствии надлежащим образом оформленного письменного требования штрафные
										санкции не начисляются и не уплачиваются.
										<br />
										Оплата штрафных санкций не освобождает от выполнения обязательств по настоящему
										Договору.
									</p>

									<p>
										<b>6.7.</b> Поставщик услуг несёт ответственность перед Пользователем по
										заключённой с ним сделке в том числе, но, не ограничиваясь: за ненадлежащую
										информацию об услуге; за вред, причинённый Пользователю вследствие недостатков
										услуги; за убытки, причинённые Пользователю; за неисполнение или ненадлежащее
										исполнение обязательств; за нарушение прав Пользователя, произошедшее по вине
										Поставщика услуг или лиц его представляющих.
									</p>

									<p>
										<b>6.8.</b> В случае если в результате действий или бездействия Поставщика
										третьим лицом в отношении Оператора предъявлены какие-либо требования, Поставщик
										обязан возместить Оператору <b>все прямые и косвенные убытки</b>, возникшие у
										Оператора в связи с предъявленными требованиями.
										<br />
										Убытки подлежат возмещению в течение <b>10 (десяти) рабочих дней</b> после
										направления Поставщику соответствующего требования.
									</p>

									<p>
										<b>6.9.</b> В случае если после подтверждения Бронирования в отношении
										конкретной Услуги Поставщик или Заказчик заключат Договор на оказание тех же
										Услуг и на те же даты <b>напрямую (минуя функционал Сервиса)</b>, Поставщик
										обязуется уплатить Оператору комиссию в размере, указанном в{' '}
										<b>Приложении №2</b>, от стоимости заключенного Договора, который Заказчик и
										Поставщик могли бы исполнить посредством Сервиса.
										<br />
										Указанная в настоящем пункте комиссия подлежит уплате Поставщиком в течение{' '}
										<b>5 (пяти) рабочих дней</b> с момента получения соответствующего письменного
										требования Оператора.
										<br />
										Размер подлежащей уплате суммы денежных средств остаётся неизменным, вне
										зависимости от условий заключенного между Заказчиком и Поставщиком Договора в
										обход Сервиса.
									</p>

									<p>
										<b>6.9.1.</b> В случае если после получения запроса/бронирования через Сервис
										или подтверждения такого бронирования Поставщик и Заказчик заключают соглашение
										на оказание тех же услуг на те же даты напрямую, минуя функционал Сервиса, и
										Поставщик умышленно не уведомил Оператора о факте такого взаимодействия,
										Поставщик обязан уплатить Оператору:
									</p>
									<ol type='a'>
										<li>
											a) Агентское вознаграждение в <b>двойном размере</b> от стоимости Заказа,
											которое могло бы быть начислено в соответствии с Приложением №2;
										</li>
										<li>
											b) Штраф в размере <b>20%</b> от стоимости такого Заказа.
										</li>
									</ol>
									<p>
										Оператор также вправе в одностороннем внесудебном порядке расторгнуть настоящий
										Договор с таким Поставщиком.
									</p>

									<p>
										<b>6.9.2.</b> В случае нарушения Поставщиком сроков перечисления комиссии
										Оператора, предусмотренных в п. 6.9. Соглашения, он обязан выплатить Оператору,
										помимо в размере комиссии <b>500 (пятьсот) рублей за каждый день просрочки</b>{' '}
										исполнения.
									</p>

									<p>
										<b>6.9.3.</b> Ответственность Сторон в случаях, не предусмотренных настоящим
										Договором, определяется в соответствии с действующим законодательством РФ.
									</p>

									<p>
										<b>6.9.4.</b> В случае умышленного сокрытия Поставщиком от Оператора полной
										стоимости Заказа (итогового чека) с целью уменьшения суммы агентского
										вознаграждения, Поставщик обязан уплатить штраф в размере{' '}
										<b>двойной суммы сокрытого вознаграждения</b>, а Оператор вправе расторгнуть
										Договор в одностороннем порядке.
									</p>

									<p>
										<b>7. ФОРМИРОВАНИЕ РЕЙТИНГА И РАБОТА С ОТЗЫВАМИ</b>
									</p>

									<p>
										<b>7.1.</b> <b>Рекомендация об оставлении отзыва.</b> После завершения оказания
										услуг и проведения расчетов Поставщик должен в корректной, ненавязчивой форме
										порекомендовать Заказчику оставить объективный отзыв о качестве услуг и Зала
										на странице Поставщика в каталоге Сервиса.
									</p>

									<p>
										<b>7.2.</b> <b>Политика в отношении отзывов.</b>
									</p>
									<p>
										<b>7.2.1.</b> Все отзывы, оставленные Заказчиками на Сайте, являются объектами
										интеллектуальной собственности их авторов (Заказчиков) и/или Оператора. Права на
										их использование принадлежат Оператору.
									</p>

									<p>
										<b>7.2.2.</b> Поставщик <u>не обладает правом</u> самостоятельно модерировать,
										редактировать, скрывать или удалять отзывы, оставленные на его странице.
									</p>

									<p>
										<b>7.2.3.</b> В случае, если Поставщик полагает, что конкретный отзыв содержит
										заведомо ложные, клеветнические сведения, нецензурную лексику, оскорбления,
										призывы к насилию или нарушает иным образом законодательство РФ, он вправе
										направить через Личный кабинет мотивированное обращение о проверке такого отзыва
										с приложением доказательств, опровергающих содержащиеся в нем сведения.
										Окончательное решение об удалении или сохранении отзыва принимается Оператором
										по своему усмотрению на основе внутренней политики и оценки соответствия отзыва
										законодательству.
									</p>

									<p>
										<b>8. КОНФИДЕНЦИАЛЬНОСТЬ И ЗАПРЕТ НА ОБХОД СЕРВИСА</b>
									</p>

									<p>
										<b>8.1.</b> Данные Заказчиков (контактная информация, история бронирований),
										полученные Поставщиком исключительно через функционал Сервиса, признаются
										конфиденциальной информацией. Поставщик обязуется использовать такие данные
										строго в целях исполнения конкретного Заказа и не вправе осуществлять их сбор,
										систематическое хранение, передачу третьим лицам или использовать в собственных
										маркетинговых целях без отдельного, явно выраженного согласия Заказчика и
										уведомления об этом Оператора.
									</p>

									<p>
										<b>8.2.</b> <b>Категорически запрещены</b> следующие действия, направленные на
										недобросовестный обход механизмов Сервиса:
									</p>
									<p>
										<b>8.2.1.</b> Любые формы склонения, убеждения или предложения Заказчикам,
										первоначально привлеченным через Сервис, к заключению последующих сделок на те
										же или аналогичные услуги напрямую, минуя процедуру бронирования через Сервис, с
										целью избежать выплаты агентского вознаграждения Оператору.
									</p>

									<p>
										<b>8.2.2.</b> Умышленное занижение Поставщиком итоговой стоимости оказанных
										Заказчику услуг при предоставлении отчетности Оператору для уменьшения суммы
										подлежащего уплате агентского вознаграждения.
									</p>

									<p>
										<b>8.2.3.</b> Сокрытие от Оператора факта того, что Заказчик был первоначально
										привлечен через Сервис Podcastbery, даже если последующее взаимодействие
										происходит по прямым каналам связи.
									</p>

									<p>
										<b>8.3.</b> Нарушение пунктов настоящего раздела Правил рассматривается как
										грубое нарушение Договора и влечет применение мер ответственности в соответствии
										с разделом 6 Договора, включая взыскание штрафов, предусмотренных пп. 6.9,
										6.9.1, 6.9.4 Правил, и безусловное право Оператора на односторонний внесудебный
										отказ от Договора.
									</p>

									<p>
										<b>9. ФОРС-МАЖОР</b>
									</p>

									<p>
										<b>9.1.</b> Стороны освобождаются от ответственности за частичное или полное
										неисполнение обязательств по настоящему Договору, если это неисполнение явилось
										следствием обстоятельств непреодолимой силы, возникших после заключения
										настоящего Договора в результате событий чрезвычайного характера, которые
										стороны не могли предвидеть и предотвратить разумными мерами. К обстоятельствам
										непреодолимой силы относятся события, на которые пострадавшая Сторона не может
										оказать влияния и за возникновение которых не несёт ответственности, в т. ч.
										стихийные бедствия, землетрясения, наводнения, ураганы, технологические
										катастрофы, эпидемии, военные действия, забастовки, правительственные меры,
										ограничивающие исполнение обязательств.
									</p>

									<p>
										<b>9.2.</b> При наступлении действия обстоятельств непреодолимой силы,
										исполнение Договора может быть приостановлено на время их действия и ликвидации,
										без каких-либо санкций по отношению к пострадавшей Стороне.
										<br />В случае, если обстоятельства непреодолимой силы действуют более{' '}
										<b>3 (трёх) месяцев</b> любая из Сторон вправе отказаться от дальнейшего
										исполнения Договор письменно уведомив об этом другую Сторону.
									</p>

									<p>
										<b>9.3.</b> Сторона, которая не исполняет свое обязательство в связи с действием
										обстоятельств непреодолимой силы, обязана письменно известить другую Сторону о
										препятствии и его влиянии на исполнение обязательств по Договору в течение{' '}
										<b>7 (семи) дней</b> с момента их возникновения.
									</p>

									<p>
										<b>9.4.</b> Сторона, ссылающаяся на обстоятельства непреодолимой силы, не
										позднее <b>15 (пятнадцати) дней</b> с момента их наступления, направляет другой
										стороне по электронной почте и (или) почтовым отправлением документальное
										подтверждение действия таких обстоятельств.
									</p>

									<p>
										<b>9.5.</b> Свидетельство или иной документ, выданный соответствующей
										Торгово-Промышленной палатой или иным компетентным органом, является достаточным
										подтверждением наличия и продолжительности действия обстоятельств непреодолимой
										силы.
									</p>

									<p>
										<b>10. ДОПОЛНИТЕЛЬНЫЕ УСЛОВИЯ</b>
									</p>

									<p>
										<b>10.1.</b> Информация, не предназначенная для публикации на Сайте и полученная
										в рамках настоящего Договора Сторонами, признаётся <b>конфиденциальной</b>.
										<br />
										Стороны обязуются не раскрывать такую информацию третьим лицам, а также не
										использовать её для иных целей, кроме как для выполнения своих обязательств по
										данному Договору, без предварительного письменного согласия другой Стороны.
									</p>

									<p>
										<b>10.2.</b> Все товарные знаки и символы, равно как и иные объекты
										исключительных прав (интеллектуальная собственность, включая авторские и смежные
										права) Поставщика услуг являются и остаются его собственностью.
										<br />
										Настоящий Договор и его исполнение не влекут за собой передачу Оператору
										каких-либо прав Поставщика услуг.
									</p>

									<p>
										<b>11. РАСТОРЖЕНИЕ ДОГОВОРА</b>
									</p>

									<p>
										<b>11.1.</b> Договор может быть расторгнут:
									</p>
									<p>
										<b>11.1.1.</b> В любое время по соглашению Сторон;
									</p>
									<p>
										<b>11.1.2.</b> Оператором незамедлительно путём направления письменного
										уведомления (в том числе по электронной почте) Поставщику услуг, в случае
										нарушения Поставщиком услуг условий настоящего Договора;
									</p>
									<p>
										<b>11.1.3.</b> Любая из Сторон после направления другой Стороне письменного
										уведомления (в том числе по электронной почте) за 5 (пять) рабочих дней до
										предполагаемой даты расторжения с учетом положений п.4.12 настоящего Договора.
									</p>

									<p>
										<b>11.2.</b> Обязательства Сторон по Договору, которые в силу своего характера
										должны сохранять действие (включая обязательства, касающиеся конфиденциальности,
										порядка оплаты, использования информации, защиты персональных данных, но, не
										ограничиваясь вышеизложенным) сохраняют свою юридическую силу после расторжения
										Договора.
									</p>

									<p>
										<b>11.3.</b> Расторжение Договора по любому основанию не освобождает Стороны от
										ответственности за нарушение условий Договора, возникших в течение срока его
										действия.
										<br />
										Расторжение Договора не освобождает Стороны от обязательств, возникших до
										прекращения его действия.
									</p>

									<p>
										<b>12. ПРОЧИЕ УСЛОВИЯ</b>
									</p>

									<p>
										<b>12.1.</b> Настоящие Правила вступают в силу для Поставщика с момента{' '}
										<b>Акцепта</b> им условий Договора и действуют в течение всего срока действия
										Договора.
									</p>

									<p>
										<b>12.2.</b> Все споры или разногласия, возникающие между Сторонами по
										настоящему Договору или в связи с ним, разрешаются путём переговоров.
										<br />В случае невозможности разрешения разногласий путём переговоров в течение{' '}
										<b>10 (десяти) рабочих дней</b> со дня направления приглашения для участия в
										таких переговорах, разногласия подлежат разрешению в суде по месту нахождения
										Оператора.
									</p>

									<p>
										<b>12.3.</b> Признание судом недействительности какого-либо положения настоящего
										Договора не влечёт за собой недействительность остальных положений.
									</p>
									<br />
									<p style={{ textAlign: 'center' }}>
										<b>ТАРИФЫ</b>
									</p>
									<br />
									<table>
										<tr>
											<th>Наименование тарифа</th>
											<th>Агентское вознаграждение (комиссия) Оператора</th>
											<th>Абонентская плата (подписка)</th>
											<th>Условия размещения и функционал</th>
										</tr>
										<tr>
											<td>
												<b>«Standart»</b>
											</td>
											<td>0% (ноль процентов).</td>
											<td>0 (ноль) рублей.</td>
											<td>
												Отображение карточки студии: до 3 фотографий, размещение без услуг и
												примеров работ, описания и оборудования Размещение в общем каталоге без
												приоритетного продвижения. Информацию о студии можно обновить раз в
												полгода Нет доступа к CRM системе
											</td>
										</tr>
										<tr>
											<td>
												<b>«PRO»</b>
											</td>
											<td>
												20% от стоимости каждого Заказа (бронирования), кроме услуг видеомонтажа
												и обработки звука, за которые комиссия составляет 10%.
											</td>
											<td>0 (ноль) рублей.</td>
											<td>
												Приоритетное размещение в каталоге выше тарифа «Standart» в вашем
												городе. Доступ к онлайн-оплате через Сервис. Обязанность оперативно
												обновлять статусы Заказов в Личном кабинете. Уникальная CRM система
												управления студией Удобный виджет бронирования студии.
											</td>
										</tr>
										<tr>
											<td>
												<b>«Premium»</b>
											</td>
											<td>0% (ноль процентов).</td>
											<td>
												Устанавливается в соответствии с действующим прайсом на Сайте,
												оплачивается авансом за выбранный период.
											</td>
											<td>
												Максимальный приоритет в продвижении. Полный доступ к функционалу
												Личного кабинета. Отсутствие комиссии с Заказов. Уникальная CRM система
												управления студией с аналитикой по вашей студии Поднятие студии выше
												Тарифа "PRO" по вашему городу Удобный виджет бронирования студии
												Модерация контента Настройка имеющихся скидок, акций, промокодов
											</td>
										</tr>
									</table>
								</div>
							</div>
						</div>
					</div>
				</div>
			) : (
				<></>
			)}
			{/* </CardWrap> */}
		</>
	)
}

export default observer(Rules)
